import { render, staticRenderFns } from "./fieldPreview.vue?vue&type=template&id=c99a8de0&scoped=true"
import script from "./fieldPreview.vue?vue&type=script&lang=js"
export * from "./fieldPreview.vue?vue&type=script&lang=js"
import style0 from "./fieldPreview.vue?vue&type=style&index=0&id=c99a8de0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99a8de0",
  null
  
)

export default component.exports